/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { useState, useEffect, useCallback } from 'react';

function getLocation() {
  return { pathname: window.location.pathname, search: window.location.search };
}

export function useLocation(): Pick<Window['location'], 'pathname' | 'search'> {
  const [{ pathname, search }, setLocation] = useState(getLocation());
  const handleChange = useCallback(() => setLocation(getLocation()), []);

  useEffect(() => {
    window.addEventListener('popstate', handleChange);
    return () => window.removeEventListener('popstate', handleChange);
  }, []);
  return { pathname, search };
}
